<template>
  <div class="product-details">
    <section class="seccion-gris margen">
      <div class="card container">
        <div class="row mb-3">
          <div class="col-lg-4 col-sm-12">
            <div class="product-image">
              <div
                @click="mostrarImagen(imgPreUrl + image_product + '.jpg')"
                class="img-fluid rounded"
                @mouseover="hover = true"
                @mouseleave="hover = false"
              >
                <image-zoom
                  img-class="img-fluid rounded"
                  :regular="imgPreUrl + image_product + '.jpg'"
                  :zoom="imgPreUrl + image_product + '.jpg'"
                />
              </div>
              <div class style="margin-top:15px">
                <ul class="list-group mb-3">
                  <li class="list-group-item d-flex justify-content-between lh-condensed">
                    <div>
                      <h6 class="my-0">Precio (unidad):</h6>
                    </div>

                    <span class="text-muted"
                      ><template v-if="product.old_price_product > product.price_product">
                        <strike style="color: grey; font-size: 13px;">{{
                          txtOldPriceinDisplay | currency
                        }}</strike>
                      </template>
                      {{ '  ' }} {{ product.price_product | currency }}</span
                    >
                  </li>
                  <li class="list-group-item d-flex justify-content-between lh-condensed">
                    <div>
                      <h6 class="my-0">Sub-Total:</h6>
                    </div>

                    <span class="text-muted" style="color:crimson !important"
                      ><template v-if="product.old_price_product > product.price_product">
                        <!--   <strike style="color: grey; font-size: 13px;">{{txtOldPriceinDisplay | currency}}</strike>   -->
                      </template>
                      {{ '  ' }} {{ txtPriceinDisplay | currency }}</span
                    >
                  </li>

                  <li class="list-group-item d-flex justify-content-between lh-condensed">
                    <div>
                      <h6 class="my-0">Cantidad:</h6>
                    </div>
                    <span class="text-muted" style="color:crimson !important">
                      <number-input
                        v-model="txtQty"
                        :min="1"
                        :max="product.stock_product"
                        center
                        controls
                        @change="modifyPriceinDisplay()"
                      ></number-input>
                    </span>
                  </li>
                </ul>
                <div class="d-none d-lg-block">
                  <template v-if="product.allowed_sale == true">
                    <button
                      class="btn btn-primary"
                      v-on:click="addToCart(product)"
                      data-toggle="modal"
                      data-target="#exampleModal"
                    >
                      <i class="fa fa-plus"></i> Añadir al carrito
                    </button>
                  </template>
                  <template v-else>
                    <small
                      ><strong
                        >Este es un producto controlado y no puede ser solicitado via web. Acérquese
                        a cualquiera de nuestras tiendas para adquirirlo.</strong
                      ></small
                    >
                  </template>
                </div>
              </div>
            </div>
            <br />
          </div>
          <div class="col-lg-8 col-sm-12">
            <div class="product-detail">
              <br />
              <h5 class="product-head text-primary">
                <strong>{{ product.name_product_es }}</strong>
              </h5>
              <table class="table" cellspacing="0" style="max-height: 28px">
                <tbody>
                  <tr>
                    <th scope="row">Código</th>
                    <td>{{ product.sku }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Producto</th>
                    <td>{{ product.name_product_es }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Descripción</th>
                    <td><span v-html="product.details_product_es"></span></td>
                  </tr>
                  <tr>
                    <th scope="row">Categorías</th>
                    <td>
                      <ul>
                        <li v-for="(level_tree, index) in categories_tree" :key="index">
                          <strong>{{ level_tree.second_level_category }}</strong>
                          {{ ' / ' + level_tree.first_level_category }}
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Marca</th>
                    <td>
                      {{ brand.desc_brand }}
                      <template v-if="brand.logo_brand != 'brands/empty-img'">
                        <img
                          v-bind:src="imgPreUrl + image_brand + 'x160.jpg'"
                          v-bind:alt="product.name_product_es"
                          class="img-fluid rounded"
                          style="width:50px;"
                        />
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <template v-if="sub_products.length == 0">
                      <th scope="row">Stock</th>
                      <td>
                        <p>
                          <template v-if="product.stock_product <= 4">
                            Quedan {{ product.stock_product }} unidad(es) en nuestros almacenes
                          </template>
                          <template v-else-if="product.stock_product > 4">
                            Stock Disponible
                          </template>
                          <template v-else>
                            Producto Agotado
                          </template>
                        </p>
                      </td>
                    </template>
                  </tr>

                  <template v-if="product.rank_star_product != 0.0">
                    <tr>
                      <th scope="row">Valoraciones/ Rating</th>
                      <td>
                        <div class="stars-outer">
                          <div
                            class="stars-inner"
                            v-bind:style="{
                              width: obtener_promedio_rating(product.rank_star_product) + '%',
                            }"
                          ></div>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <template v-if="sub_products.length != 0">
                <div class="row">
                  <div class="col-sm-6">
                    <p><strong>Lotes Disponibles:</strong></p>

                    <div class="row">
                      <template v-for="sub_product in sub_products">
                        <div class="col-sm-12 col-lg-4" style="text-align: center;">
                          <div class="product-label-discount">
                            <span
                              class="new-discount"
                              v-if="
                                Math.round(
                                  100 - sub_product.price_sub_product / (precio_base_lista / 100),
                                ) != 0
                              "
                            >
                              -{{
                                Math.round(
                                  100 - sub_product.price_sub_product / (precio_base_lista / 100),
                                )
                              }}%
                            </span>
                          </div>
                          <button
                            :class="
                              lote_sku == sub_product.sub_product_sku
                                ? 'btn  btn-info ancho-total btn-lote'
                                : 'btn  btn-secondary ancho-total btn-lote'
                            "
                            @click="seleccionar_lote(sub_product)"
                          >
                            {{ sub_product.sub_product_sku }}
                          </button>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <template v-if="precio_base_lista == sub_product_price">
                      <p>
                        <strong>Precio Lista: </strong>
                        <span style="color:red;">{{ precio_base_lista | currency }}</span>
                      </p>
                    </template>
                    <template v-else>
                      <p>
                        <strong>Precio Lista: </strong>
                        <span
                          ><strike> {{ precio_base_lista | currency }}</strike></span
                        >
                      </p>
                      <p>
                        <strong>Precio Oferta: </strong>
                        <span style="color:red;"> {{ sub_product_price | currency }}</span>
                        {{
                          '(-' +
                            Math.round(100 - sub_product_price / (precio_base_lista / 100)) +
                            '% Desc)'
                        }}
                      </p>
                    </template>
                    <p><strong>Vida útil:</strong> {{ vida_util }}</p>
                    <p>
                      <strong>Fecha de Vencimiento</strong>:
                      {{ sub_product_fec_ven | formatOnlyLatinDate }}
                    </p>
                    <p><strong>Unidades Disponibles: </strong>: {{ sub_product_stock }}</p>
                  </div>
                </div>
              </template>

              <br />

              <div class="col-sm-12 d-lg-none" style="text-align: center;">
                <template v-if="product.allowed_sale == true">
                  <button
                    class="btn btn-primary"
                    v-on:click="addToCart(product)"
                    data-toggle="modal"
                    data-target="#exampleModal"
                  >
                    <i class="fa fa-plus"></i> Añadir al carrito
                  </button>
                </template>
                <template v-else>
                  <small
                    ><strong
                      >Este es un producto controlado y no puede ser solicitado via web. Acérquese a
                      cualquiera de nuestras tiendas para adquirirlo.</strong
                    ></small
                  >
                </template>
              </div>

              <br />

              <small>(*) Los precios Incluyen IGV. </small><br />
              <small
                >(*) Las fotos son referenciales y pueden variar respecto del producto
                original.</small
              >
            </div>
          </div>
        </div>

        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">Ranking y Valoraciones</li>
          </ol>
        </nav>
        <div class="row">
          <div class="col-md-12">
            <div class="panel panel-info">
              <div class="panel-body">
                <ul class="media-list">
                  <template v-if="logged">
                    <li class="media">
                      <div class="media-body">
                        <div class="media">
                          <a class="pull-left" href="#">
                            <img
                              v-bind:src="imgPreUrl + user.photo_client + 'x160.jpg'"
                              alt="Usuario"
                              class="media-object img-wallpaper-min"
                              style="max-height: 60px; max-width: 60px;"
                            />
                          </a>
                          <div class="media-body">
                            <div class="form-group">
                              <form v-on:submit.prevent="addComment()">
                                <label for=""
                                  >Su Valoración:
                                  <vue-stars
                                    name="demo"
                                    v-model="txtRanking"
                                    :max="5"
                                    :value="5"
                                    :readonly="false"
                                /></label>
                                <div class="row">
                                  <div class="col-md-10">
                                    <input
                                      v-model="txtyourcomment"
                                      type="text"
                                      class="form-control"
                                      placeholder="Ingresa tu comentario aquí"
                                      required
                                      maxlength="300"
                                    />
                                  </div>
                                  <div class="col-md-2">
                                    <button type="sumbit" class="btn btn-info">Enviar</button>
                                  </div>
                                </div>
                                <br /><small class="text-muted">Usted | Hoy</small>
                                <hr />
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </template>
                  <template v-else-if="!logged && product.rank_star_product == 0.0">
                    Este producto aún no tiene comentarios. Inicia sesión para realizar una
                    valoración.
                  </template>

                  <template v-if="product.rank_star_product != 0.0">
                    <template v-if="loading_comments">
                      <i class="fa fa-refresh fa-spin fa-3x fa-fw fa-mrbig"></i>
                    </template>
                    <template v-else>
                      <template v-for="comentary in comments">
                        <li class="media">
                          <div class="media-body">
                            <div class="media">
                              <a class="pull-left">
                                <img
                                  v-bind:src="
                                    imgPreUrl + comentary.cliente.photo_client + 'x160.jpg'
                                  "
                                  v-bind:alt="comentary.cliente.nick_client"
                                  class="media-object img-wallpaper-min"
                                  style="max-height: 60px; max-width: 60px;"
                                />
                              </a>
                              <div class="media-body">
                                <h6 class="comentary-name">
                                  {{
                                    comentary.cliente.name_client +
                                      ' ' +
                                      comentary.cliente.surname_client
                                  }}
                                  <div class="stars-outer">
                                    <div
                                      class="stars-inner"
                                      v-bind:style="{
                                        width: obtener_promedio_rating(comentary.ranking) + '%',
                                      }"
                                    ></div>
                                  </div>
                                </h6>
                                {{ comentary.comentario }}
                                <br /><small class="text-muted"
                                  >{{
                                    comentary.cliente.name_client +
                                      ' ' +
                                      comentary.cliente.surname_client
                                  }}
                                  | {{ comentary.fecha_valoracion | formatDate }}</small
                                >
                                <hr />
                              </div>
                              <template v-if="comentary.cliente.nick_client == user.nick_client">
                                <a
                                  class="pull-right"
                                  @click="deleteComment(comentary.id_valoracion)"
                                >
                                  <button class="btn btn-danger">
                                    <i class="fa fa-trash"></i>
                                  </button>
                                </a>
                              </template>
                            </div>
                          </div>
                        </li>
                      </template>
                    </template>
                    <li class="media">
                      <div class="media-body">
                        <div class="col-sm-12">
                          <div class="btn-group ancho-total">
                            <button
                              class="btn more-comments"
                              @click="comentarios_usuariosxproducto(numcomments + 5)"
                            >
                              Ver más comentarios
                            </button>
                          </div>
                        </div>
                      </div>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <template v-if="similarProduct.length > 0">
          <nav aria-label="breadcrumb ">
            <ol class="breadcrumb">
              <li class="breadcrumb-item active" aria-current="page">
                Productos que te pueden interesar
              </li>
            </ol>
          </nav>
          <div class="row">
            <div class="col-md-3 mt-3" v-for="(item, index) in similarProduct" :key="index">
              <CardTemplateDiscount :item="item" />
            </div>
          </div>
        </template>
      </div>
    </section>
    <GoToTrackingModule />
    <GuideModule />
    <PiuraFreightModal
      :visible="showPiuraFreightModal"
      :product-name="pendingCartProduct ? pendingCartProduct.name_product_es : ''"
      :stock="piuraFreightStock"
      @confirm="onPiuraFreightConfirm"
      @cancel="onPiuraFreightCancel"
    />
  </div>
</template>

<script>
import VueBarcode from 'vue-barcode';
import GoToTrackingModule from '@/modules/GoToTrackingModule.vue';
import GuideModule from '@/modules/GuideModule.vue';
import axios from 'axios';
import { config_settings } from '@/config.js';
import { mapState, mapActions, mapMutations } from 'vuex';
import CardTemplateDiscount from '@/components/products/catalog/CardTemplateDiscount';
import PiuraFreightModal from '@/components/general/Modals/PiuraFreightModal.vue';
import { getStoreStockBySku } from '@/service/stock.service.js';
import { getPiuraStockQty, hasOnlyPiuraStock } from '@/helpers/stock.helpers.js';
import {
  errorToaster,
  infoToaster,
  successToaster,
} from '@/components/shared/service/ErrorHandler.js';

//HTTP ERROR STATUS
const NOT_FOUND = 404;
const BAD_REQUEST = 400;
const UNAUTHORIZED = 401;
const INTERNAL_SERVER_ERROR = 500;

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.message === 'Network Error') {
      toastr.error(
        'No se puede conectar con el servidor. Verifique su conexión a internet',
        'ERROR',
        { iconClass: 'customer-danger' },
      );
    } else if (error.response.status === UNAUTHORIZED) {
      if (error.response.data.message === 'Access is denied') {
        toastr.error('Usted no tiene los provilegios para acceder a esta sección', 'ERROR', {
          iconClass: 'customer-danger',
        });
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  },
);

export default {
  name: 'productDetails',
  data() {
    return {
      hover: false,
      loading_comments: false,
      user: new Object(),
      logged: false,
      numcomments: 0,
      txtPriceinDisplay: 0,
      txtOldPriceinDisplay: 0,
      txtQty: 1,
      code_product: this.$route.params.id,
      product: new Object(),
      rating: new Object(),
      sub_categoria: new Object(),
      brand: new Object(),
      similarProduct: [],
      comments: [],
      txtyourcomment: '',
      txtRanking: 5,
      stock_stores: [],
      loading_stock_stores: false,
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      image_product: 'products/empty-img',
      image_brand: 'brands/empty-img',
      sub_products: [],
      desc_lote: '',
      vida_util: '',
      sub_product_fec_ven: '',
      sub_product_stock: '',
      sub_product_stock_number: 0,
      sub_product_price: '',
      precio_base_lista: '',
      id_lote: 0,
      lote_sku: '',
      categories_tree: [],
      showPiuraFreightModal: false,
      pendingCartProduct: null,
      piuraFreightStock: 0,
      addingToCart: false,
    };
  },
  computed: mapState(['cartProducts', 'loggedUser']),
  components: {
    GuideModule,
    VueBarcode,
    CardTemplateDiscount,
    PiuraFreightModal,
  },

  watch: {
    $route: function(route) {
      this.code_product = route.params.id;
      this.detalle_producto();
      this.scroll_inicio();
      this.close_collapse();
      this.subproductosxproducto();
    },
  },

  methods: {
    close_collapse() {
      this.stock_stores = [];
      document.getElementById('collapseExample').className = 'collapse';
    },

    seleccionar_lote(sub_product) {
      if (this.id_lote == sub_product.id_sub_product) {
      } else {
        this.desc_lote = sub_product.detail_description;
        this.vida_util = sub_product.days_until_expiration + ' días';
        this.sub_product_fec_ven = sub_product.fec_param;
        this.product.price_product = sub_product.price_sub_product;
        this.product.stock_product = sub_product.stock;
        this.sub_product_price = sub_product.price_sub_product;
        this.lote_sku = sub_product.sub_product_sku;
        this.sub_product_stock_number = sub_product.stock;
        if (sub_product.stock <= 10) {
          this.sub_product_stock = 'Menos de 10 unidades';
        } else if (sub_product.stock >= 10 && sub_product.stock <= 20) {
          this.sub_product_stock = 'Más de 10 unidades';
        } else {
          this.sub_product_stock = 'Más de 20 unidades';
        }
        this.modifyPriceinDisplay();
        this.txtQty = 1;
        this.id_lote = sub_product.id_sub_product;
      }
    },

    refreshToken() {
      var refresh_token = localStorage.getItem('refresh_token');
      var refresh_credentials = new FormData();
      refresh_credentials.append('grant_type', 'refresh_token');
      refresh_credentials.append('refresh_token', refresh_token);
      refresh_credentials.append('id_store', config_settings.STORE);

      const refreshingCall = axios({
        method: 'post',
        url: config_settings.AUTH_SERVER_URL + '/oauth/token',
        data: refresh_credentials,
        withCredentials: true,
        auth: {
          username: 'USER_CLIENT_APP',
          password: 'password',
        },
      }).then((response) => {
        localStorage.setItem('access_token', response.data.access_token);
        localStorage.setItem('refresh_token', response.data.refresh_token);
        return Promise.resolve(true);
      });
      return refreshingCall;
    },

    callUserInformation() {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/profile',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          this.user = response.data;
          this.logged = true;
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.callUserInformation();
              })
              .catch((_) => {
                this.logged = false;
              });
          }
          this.logged = false;
        });
    },

    mostrarImagen(url) {
      this.$zoom(url);
    },

    addComment() {
      var json_data = {
        comentario: this.txtyourcomment,
        ranking: this.txtRanking,
      };

      axios({
        method: 'post',
        url:
          config_settings.RESOURCE_SERVER_URL +
          '/POST/catalog/products/' +
          this.code_product +
          '/assessments',
        data: json_data,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          this.txtyourcomment = '';
          this.txtRanking = 5;
          this.detalle_producto();
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.addComment();
              })
              .catch((_) => {
                this.logged = false;
              });
          }
          this.logged = false;
        });
    },

    deleteComment(id_valoracion) {
      axios({
        method: 'delete',
        url:
          config_settings.RESOURCE_SERVER_URL +
          '/DELETE/catalog/products/' +
          this.code_product +
          '/assessments/' +
          id_valoracion,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          this.detalle_producto();
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.deleteComment(id_valoracion);
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.$router.push({ path: '../../pages/login/' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },

    scroll_inicio() {
      window.scrollTo(0, 0);
    },
    obtener_promedio_rating(rank) {
      const total_estrellas = 5;
      const porcentaje_estrellas = (rank / total_estrellas) * 100;
      const redondeado_a_diez = (porcentaje_estrellas / 10) * 10;
      return redondeado_a_diez;
    },
    detalle_producto() {
      axios
        .get(config_settings.RESOURCE_SERVER_URL + '/GET/catalog/products/' + this.code_product)
        .then((response) => {
          this.product = response.data;
          this.txtPriceinDisplay = this.product.price_product;
          this.txtOldPriceinDisplay = this.product.old_price_product;
          this.sub_categoria = response.data.subcategory_product;
          this.brand = response.data.brand_product;
          this.image_brand = this.brand.logo_brand;
          this.image_product = this.product.photo_product;
          // Getting Similar Product
          this.getSimilarProduct(this.sub_categoria.id_category);
          if (this.product.rank_star_product != 0.0) {
            this.comentarios_usuariosxproducto(5);
          }
          this.subproductosxproducto();
          this.asignarVisita();
          this.categoriasxproducto();
          this.precio_base_lista = this.product.price_product;
        })
        .catch((error) => {
          errorToaster('Server ERROR 404', 'No se encuentra el producto seleccionado');
          this.$router.push({ path: '../../../404' });
        });
    },

    subproductosxproducto() {
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/catalog/products/' +
            this.code_product +
            '/subproducts/all',
        )
        .then((response) => {
          this.sub_products = response.data;
          this.seleccionar_lote(this.sub_products[0]);
        })
        .catch((error) => {
          this.sub_products = [];
        });
    },

    categoriasxproducto() {
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/catalog/products/' +
            this.code_product +
            '/categories-tree',
        )
        .then((response) => {
          this.categories_tree = response.data;
        })
        .catch((error) => {
          this.categories_tree = [];
        });
    },

    consultarStock(sku) {
      this.loading_stock_stores = true;
      axios
        .get(
          config_settings.OTHER_SERVICES_RESOURCE_SERVER_URL +
            '/GET/store_armaq/stock/product/' +
            sku,
        )
        .then((response) => {
          this.stock_stores = response.data;
          this.loading_stock_stores = false;
        })
        .catch((error) => {
          this.loading_stock_stores = false;
        });
    },
    asignarVisita() {
      axios
        .put(
          config_settings.RESOURCE_SERVER_URL +
            '/PUT/catalog/products/' +
            this.code_product +
            '/views',
        )
        .then((response) => {})
        .catch((error) => {});
    },

    modifyPriceinDisplay() {
      let price = this.product.price_product;
      let old_price = this.product.old_price_product;
      this.txtPriceinDisplay = this.txtQty * price;
      this.txtOldPriceinDisplay = this.txtQty * old_price;
    },

    comentarios_usuariosxproducto(entradanum) {
      this.loading_comments = true;

      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/catalog/products/' +
            this.code_product +
            '/assessments?cReg=' +
            entradanum,
        )
        .then((response) => {
          let localcomments = response.data.assessments;
          localcomments.forEach((element) => {
            const total_estrellas = 5;
            const porcentaje_estrellas = (element.rating / total_estrellas) * 100;
            const redondeado_a_diez = (porcentaje_estrellas / 10) * 10;
            element.percentRank = redondeado_a_diez;
          });
          this.comments = localcomments;

          this.numcomments = entradanum;
          this.loading_comments = false;
        })
        .catch((error) => {
          //errorToaster("Error while fetching similar products", "");
          this.loading_comments = false;
        });
    },
    getSimilarProduct(variable) {
      this.loading = true;
      var string =
        config_settings.RESOURCE_SERVER_URL + '/GET/catalog/products?xPag=5&cat=' + variable;
      axios
        .get(string)
        .then((response) => {
          var arreglo_servicio = response.data.products;
          const index = arreglo_servicio.findIndex(
            (prod) => prod.code_product === this.code_product,
          );
          arreglo_servicio.splice(index, 1);
          this.similarProduct = arreglo_servicio;
          this.loading = false;
        })
        .catch((error) => {
          //  errorToaster("The server encountered an unexpected condition.","Internal Error 500");
        });
    },

    ...mapMutations(['ADD_CART_LOCAL']),

    finalizeAddToCart(product) {
      successToaster(
        'Añadido exitosamente:',
        'El producto fue agregado exitosamente al carrito.',
      );
      product.qty = this.txtQty;
      this.ADD_CART_LOCAL(product);
      this.detalle_producto();
      this.callUserInformation();
    },

    onPiuraFreightConfirm() {
      this.showPiuraFreightModal = false;
      this.piuraFreightStock = 0;
      if (this.pendingCartProduct) {
        this.finalizeAddToCart(this.pendingCartProduct);
        this.pendingCartProduct = null;
      }
    },

    onPiuraFreightCancel() {
      this.showPiuraFreightModal = false;
      this.pendingCartProduct = null;
      this.piuraFreightStock = 0;
    },

    addToCart(product) {
      if (this.addingToCart) {
        return;
      }

      product.subproduct = {
        id_lote: this.id_lote,
        lote_sku: this.lote_sku,
        lote_stock: this.sub_product_stock_number,
        base_price: this.precio_base_lista,
      };

      const data = this.cartProducts.find((prod) => prod.code_product === product.code_product);

      if (data) {
        const data2 = this.cartProducts.find(
          (prod) => prod.subproduct.lote_sku === product.subproduct.lote_sku,
        );

        if (data2) {
          infoToaster('Producto ya existente:', 'El producto ya se encuentra agregado al carrito.');
          return;
        }
      }

      const sku = product.sku || this.lote_sku;
      this.addingToCart = true;

      getStoreStockBySku(sku)
        .then((response) => {
          const onlyPiura = hasOnlyPiuraStock(response.data);
          product.only_piura_freight = onlyPiura;
          if (onlyPiura) {
            this.pendingCartProduct = Object.assign({}, product, {
              subproduct: Object.assign({}, product.subproduct),
            });
            this.piuraFreightStock = getPiuraStockQty(response.data);
            this.showPiuraFreightModal = true;
          } else {
            this.finalizeAddToCart(product);
          }
        })
        .catch(() => {
          product.only_piura_freight = false;
          this.finalizeAddToCart(product);
        })
        .finally(() => {
          this.addingToCart = false;
        });
    },
  },
  created() {
    this.detalle_producto();
    this.callUserInformation();
    this.scroll_inicio();
    // this.getSimilarProduct();
  },
};
</script>

<style>
@media (min-width: 992px) {
  .product-details {
    padding-top: 110px;
  }
}
.product-details {
  .margen {
    padding-top: 20px;
    padding-bottom: 60px;
  }
  .card {
    height: inherit !important;
  }

  .more-comments {
    background-color: #a9a9a945;
  }

  .fa-mrbig {
    font-size: 80px;
    color: crimson;
  }

  .btn-danger {
    background-color: #dc35456b;
  }

  .product-detail {
    text-align: start;
  }

  .product-detail .product-head {
    padding: 10px;
    font-weight: 500;
  }

  .product-detail .table th {
    width: 152px;
  }

  .product-ship {
    height: 15rem;
  }

  .stars-outer {
    display: inline-block;
    position: relative;
    font-family: FontAwesome;
  }

  .stars-outer::before {
    content: '\f006 \f006 \f006 \f006 \f006';
  }

  .stars-inner {
    position: absolute;
    top: 0;
    left: 0;
    white-space: nowrap;
    overflow: hidden;
    width: 0;
  }

  .stars-inner::before {
    content: '\f005 \f005 \f005 \f005 \f005';
    color: #f8ce0b;
  }

  .comentary-name {
    color: #385898;
    font-weight: bold;
  }

  .panel-info {
    border-color: #bce8f1;
    padding-bottom: 20px;
  }
  .media-body {
    text-align: -webkit-auto;
    padding-left: 20px;
  }
  .media-list {
    padding-left: 0;
    list-style: none;
  }

  .img-wallpaper-min {
    max-width: 60px;
    height: 60px;
    border-radius: 50em;
  }

  .button-add {
    width: 100%;
    color: #007bff;
    border: solid 2px;
  }
}
</style>
